<template>
<div class="ny_pad">
	<div class="menu_ico">
	 <top_menu></top_menu>
	 </div>
<!--  about_lay tz-->
	 <div class="" id="dj1">
	   <div class="about_wapper">
       <img  :src="imgb" />
	   </div>
	 </div>


  <div class="container">
    <div class="row pd10"><img src="@/assets/images/sy.png" /></div>
    <div class="">
      <div class="row">
        <div class="col-lg-12">


          <dl class="sousuo_list" style="width: 70%;margin: 20px auto; display: block;border-bottom: none;">
            <form @submit.prevent="syysousuo">
              <div class="input-group ">
                <input type="text" maxlength="50" id="scode" name="scode" v-model="scode"  class="form-control">
                <span class="input-group-btn">
                        <input type="submit" value="验证产品" class="btn btn-default" />
                    </span>
              </div>
            </form>
          </dl>



          <dl class="sousuo_list">
            <dt style="text-align: center;"><a href="https://foodcredit.miit.gov.cn" target="_blank"  style="color: #c66f0d;">食品工业企业质量安全追溯平台 婴配乳粉追溯</a></dt>
            <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6">
              <a href="https://foodcredit.miit.gov.cn" target="_blank" style="color: #c66f0d;"><img  src="@/assets/images/gwx.png" style="max-width: 100%;width:300px"/>
                微信二维码</a>
            </div>
            <div  class="col-lg-6 col-md-6 col-sm-6">
              <a href="https://foodcredit.miit.gov.cn" target="_blank"  style="color: #c66f0d;"><img  src="@/assets/images/douyincx.jpg" style="max-width: 100%;width:300px"/>
                抖音小程序二维码</a>
            </div>
            </div>
            <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12"><img  src="@/assets/images/gxz.jpg" style="max-width: 100%;"/></div>
            </div>
          </dl>
		  
		  <!-- <dl class="sousuo_list">
		    <dt style="text-align: center;"><a href="https://foodcredit.miit.gov.cn/#/zs/zhuisu.html" target="_blank"  style="color: #c66f0d;">食品工业企业质量安全追溯平台 婴配乳粉追溯</a></dt>
		    <div class="row">
		    <div class="col-lg-6 col-md-6 col-sm-6">
		      <a href="https://foodcredit.miit.gov.cn/#/zs/zhuisu.html" target="_blank" style="color: #c66f0d;"><img  src="@/assets/images/gwx.png" style="max-width: 100%;width:300px"/>
		        微信二维码</a>
		    </div>
		    <div  class="col-lg-6 col-md-6 col-sm-6">
		      <a href="https://foodcredit.miit.gov.cn/#/zs/zhuisu.html" target="_blank"  style="color: #c66f0d;"><img  src="@/assets/images/douyincx.jpg" style="max-width: 100%;width:300px"/>
		        抖音小程序二维码</a>
		    </div>
		    </div>
		    <div class="row">
		    <div class="col-lg-12 col-md-12 col-sm-12"><img  src="@/assets/images/gxz.jpg" style="max-width: 100%;"/></div>
		    </div>
		  </dl> -->



          <!-- Corpix Marketing Content End -->
        </div>

      </div>
    </div>
  </div>


	 <fo_oter></fo_oter>
	<!-- footer -->
</div>
</template>
<style>
.sousuo_list dt {
  font-size: 28px;
}
</style>
<script>
import top_menu from '../components/menu.vue'
import fo_oter from '../components/footer.vue'
// import "@/assets/js/jquery-1.9.1.min.js";
import "@/assets/js/jquery-3.7.1.min.js";
import "@/assets/bootstrap/bootstrap.min.js";
import {GETDATA1,GETDATA2,GETDATA3,GETDATA4} from '../apis/dj.js'
import {GETADDATA, GETLISTDATA} from "@/apis/api";
export default {
  name: 'dj',
  components: {
    top_menu,fo_oter
  },
  data() {
    return {
		testdata:[],
		testdata1:[],
		testdata2:[],
		testdata3:[],
      imgb:""
    };
  },
  mounted() {
	  this.onloading();
  },
  methods: {
  	  async onloading(){
        GETLISTDATA({catid:61,pageNum:1,pageSize:6}).then((res) => {
          if(res.code == 200){
            this.testdata = res.rows;
          }
        });
        GETADDATA({id:6}).then((res) => {
          if(res.code == 200){
            this.imgb = res.data.content[0].source;
          }
        });
        GETLISTDATA({catid:62,pageNum:1,pageSize:6}).then((res) => {
          if(res.code == 200){
            this.testdata1 = res.rows;
          }
        });

  	  },
      syysousuo(event) {
        if (this.scode) {
          //window.location.href = "http://www.foodcredit.org.cn/zs/traceInfo_ministry?enterpriseCode=86.1000.17&traceCode=86.1000.17/" + this.scode;
          /* window.open("http://www.foodcredit.org.cn/zs/traceInfo_ministry?enterpriseCode=86.1000.17&traceCode=86.1000.17/"+this.scode); */
		  window.open("https://foodcredit.miit.gov.cn/zs/traceInfo_ministry_first_foodcredit?enterpriseCode=86.1000.17&traceCode=86.1000.17%2F"+this.scode+"&referral=null");
        }
      }
  }
}
</script>